import { getFormatter } from 'data/services/date/formatter';
import { Fragment, useState } from 'react';
import TimelineItem from './timelineItem';
import {
    HistoryContainer,
    HistoryHeader,
    Date,
} from './styled';
import { HistoryItem } from './types';
import VersionsDiffViewerModal from './VersionsDiffViewerModal';

interface Props {
    items: Array<HistoryItem>;
    selectedItem?: HistoryItem | null;
    onSelectedVersion?: (version: HistoryItem) => void;
}

const versionDateFormatter = getFormatter('en-US', {
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    year: 'numeric',
});

const groupByDate = (versions: HistoryItem[]) => {
    const groups: {
        key: string;
        value: HistoryItem[];
    }[] = [];

    versions.forEach((version) => {
        const date = versionDateFormatter.format(version.createdAt);
        const group = groups.find((g) => g.key === date);
        if (group) {
            group.value.push(version);
        } else {
            groups.push({
                key: date,
                value: [version],
            });
        }
    });
    return groups;
};

const History = ({
    items,
    selectedItem,
    onSelectedVersion = () => {},
}: Props) => {
    const [diffModalOpen, setDiffModalOpen] = useState(false);
    const [diffVersion, setDiffVersion] = useState<HistoryItem | undefined>(undefined);
    const handleVersionSelect = (version: HistoryItem) => {
        setDiffVersion(version);
        setDiffModalOpen(true);
    };
    const currentVersion = items.find((item) => item.id === selectedItem?.id);
    const groupedByDate = groupByDate(items);
    return (
        <HistoryContainer>
            {
                groupedByDate.map((group) => {
                    const { key, value } = group;
                    return (
                        <Fragment key={key}>
                            <HistoryHeader>
                                <Date>{key}</Date>
                            </HistoryHeader>
                            <div className="rainbow-m-bottom_large">
                                {
                                    value.map((version) => (
                                        <TimelineItem
                                            key={version.id}
                                            current={version.id === selectedItem?.id}
                                            version={version}
                                            onClick={
                                                (selectedVersion) => handleVersionSelect(
                                                    selectedVersion,
                                                )
                                            }
                                        />
                                    ))
                                }
                            </div>
                        </Fragment>
                    );
                })
            }
            <VersionsDiffViewerModal
                isOpen={diffModalOpen}
                actualVersionContent={diffVersion?.value || ''}
                previousVersionContent={currentVersion?.value || ''}
                previousVersionDate={diffVersion?.createdAt as Date}
                previousVersionAuthor={diffVersion?.createdBy?.email || ''}
                previousVersionNumber={diffVersion?.number || 0}
                onRequestClose={() => setDiffModalOpen(false)}
                onRestoreVersion={() => {
                    setDiffModalOpen(false);
                    onSelectedVersion(diffVersion as HistoryItem);
                }}
            />
        </HistoryContainer>
    );
};

export default History;
